import { useState } from "react";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/track";
import { useSiteSettings, eur } from "@/lib/siteSettings";
import CheckoutDialog from "./CheckoutDialog";
import { S } from "./summaryCopy";
import { SALES } from "./salesConfig";

// The one primary purchase button, reused in the top block and after the
// comparison. Price comes from the site settings (report_price_eur, default 39).
// payments live -> checkout dialog; otherwise it scrolls to the offer block,
// whose request form is the only flow that exists until payment is wired.
export default function ReportCta({ token, lang, placement, className = "" }) {
  const settings = useSiteSettings();
  const paymentsLive = settings.payments_live === true;
  const [open, setOpen] = useState(false);
  const o = (S[lang] || S.de).offer;
  const price = eur(settings.report_price_eur, lang);
  const go = () => {
    trackEvent(token, "cta_clicked", { placement });
    if (paymentsLive) {
      setOpen(true);
      return;
    }
    document.getElementById("angebot")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className={`print:hidden ${className}`}>
      <Button size="lg" className="w-full sm:w-auto" onClick={go} data-testid={`report-cta-${placement}`}>
        {SALES.paymentLive || paymentsLive ? o.ctaPay(price) : o.ctaRequest(price)}
      </Button>
      {paymentsLive && <CheckoutDialog open={open} onOpenChange={setOpen} token={token} product="report" lang={lang} />}
    </div>
  );
}
